// src/pages/FAQ.jsx
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  ChevronDown, 
  UserPlus,    // ثبت نام
  CreditCard,  // شارژ کیف
  RefreshCw,   // به‌روزرسانی قیمت
  Shield,      // کارمزد
  Package,     // طلای فیزیکی
  Clock,       // ساعت معامله
  Phone,       // تماس
  MessageCircle // چت
} from '../components/icons';

const faqs = [
  {
    id: 1,
    question: "چطور ثبت نام کنم؟",
    answer: "فقط شماره موبایل و کد ملی و تاریخ را وارد کنید. کد تایید پیامک میشه. در کمتر از ۱ دقیقه آماده‌اید!",
    icon: UserPlus
  },
  {
    id: 2,
    question: "کیف پول رو چطور شارژ کنم؟",
    answer: "از منوی «واریز برداشت» مبلغ وارد کنید عکس فیش را انتخاب کنید و تأیید.",
    icon: CreditCard
  },
  {
    id: 3,
    question: "قیمت طلا چقدر به‌روز میشه؟",
    answer: "هر ۱۰ ثانیه یک بار! قیمت‌ها مستقیم از بازار و اتحادیه طلا گرفته میشه.",
    icon: RefreshCw
  },
  {
    id: 4,
    question: "خرید و فروش چقدر کارمزد داره؟",
    answer: "نرخ کارمزد به دلیل نوسانات متغییر می باشد. در زمان خرید یا فروش قیمتها مشخص هست.",
    icon: Shield
  },
  {
    id: 5,
    question: "تفاوت کارمز شما با سایتهای دیگر در چی هست؟",
    answer: "در سایتهای دیگر نیم درصد کارمزد روی خرید و فروش دارد و در زمان تحویل آبشده 3 درصد کارمزد دریافت می کند. ولی در Esf.Gold کارمزد خرید یا فروش تقریبا %0.6 هست و در زمان تحویل آبشده هیچ کارمزدی از شما عزیزان دریافت نمیشود. پس میتوان گفت نسبت به رقبا بسیار به صرفه تر است.",
    icon: Shield
  },
  {
    id: 6,
    question: "برداشت از کیف پول زده ام. چه زمانی واریز می شود؟",
    answer: "اگر کارت شما بلو بانک باشد، پول شما در کمترین زمان ممکن به حساب مقصد واریز می‌شود. اما اگر کارت شما مربوط به بانک دیگری باشد، انتقال وجه طبق روال سیستم پایا انجام می‌شود.",
    icon: Shield
  },
  {
    id: 7,
    question: "آیا میتوانم با حسابی که به نام شخص دیگری هست پول واریز کنم؟",
    answer: "خیر. درصورتی که مغایرت در نام داشته باشد، کیف پول شما شارژ نمی شود و مبلغ فوق پس از گذشت 72 ساعت به حساب مبدا عودت داده می شود.",
    icon: Shield
  },
  {
    id: 8,
    question: "طلای من کجاست؟",
    answer: "طلای شما نزد ما امانت می باشد تا زمانی که وزن موجودی شما با یکی از آبشده ها برابر باشد.",
    icon: Package
  },
  {
    id: 9,
    question: "چطور طلای فیزیکی بگیرم؟",
    answer: "از منوی «درخواست آبشده» ← وزن انتخاب کنید ← منتظر تایید مدیر بمانید ← در شعب تحویل بگیرید.",
    icon: Package
  },
  {
    id: 10,
    question: "حداقل خرید چقدره؟",
    answer: "حداقل ۰.۱۰۰ گرم!",
    icon: CreditCard
  },
  {
    id: 11,
    question: "در چه ساعاتی میتوان معامله کرد؟",
    answer: "خرید: ۱۱:۳۰ صبح تا ۸ شب\nفروش: ۱۱:۳۰ صبح تا ۸ شب\nدر روزهای تعطیل غیرفعال است!",
    icon: Clock
  },
  {
    id: 12,
    question: "چطور با پشتیبانی تماس بگیرم؟",
    answer: (
      <div className="space-y-2">
        <p className="flex items-center gap-2"><Phone className="w-4 h-4" /> ۰۳۱-۳۲۲۲۲۰۴۲</p>
        <p className="flex items-center gap-2"><Phone className="w-4 h-4" /> ۰۹۲۱-۵۳۱-۶۰۱۲</p>
        <p className="flex items-center gap-2"><MessageCircle className="w-4 h-4" /> چت آنلاین در اپ</p>
      </div>
    ),
    icon: Phone
  }
];

export default function FAQ() {
  const [openId, setOpenId] = useState(null);
  const [search, setSearch] = useState('');
  const searchable = value => String(value).replace(/ي/g, 'ی').replace(/ك/g, 'ک').replace(/\u200c/g, ' ').toLowerCase();
  const filteredFaqs = faqs.filter(faq => searchable(`${faq.question} ${typeof faq.answer === 'string' ? faq.answer : ''}`).includes(searchable(search).trim()));

  const toggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-20 px-6">
      {/* هدر */}
      <div className="max-w-4xl mx-auto text-center mb-16">
        <motion.h1 data-page-title="true"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-bold text-gray-800 mb-4"
        >
          سوالات متداول
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-lg text-gray-600"
        >
          جواب سوالتون رو پیدا نکردید؟ با پشتیبانی تماس بگیرید.
        </motion.p>
      </div>

      {/* لیست سوالات */}
      <div className="faq-design-search"><label htmlFor="faq-design-search">جست‌وجو در پرسش‌ها و پاسخ‌ها</label><input id="faq-design-search" type="search" value={search} onChange={event => setSearch(event.target.value)} placeholder="مثلاً برداشت، ثبت‌نام یا تحویل طلا" /><p role="status">{filteredFaqs.length.toLocaleString('fa-IR')} پرسش</p></div>
      <div className="max-w-4xl mx-auto space-y-4">
        {filteredFaqs.map((faq) => {
          const Icon = faq.icon;
          const isOpen = openId === faq.id;

          return (
            <motion.div
              key={faq.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: faq.id * 0.05 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden"
            >
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${faq.id}`}
                onClick={() => toggle(faq.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-right hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className={`p-2 rounded-xl ${isOpen ? 'bg-amber-100 text-amber-600' : 'bg-gray-100 text-gray-600'}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <span className="font-semibold text-gray-800 text-lg">
                    {faq.question}
                  </span>
                </div>
                <motion.div
                  animate={{ rotate: isOpen ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDown className="w-5 h-5 text-gray-500" />
                </motion.div>
              </button>

              <AnimatePresence>
                {isOpen && (
                  <motion.div
                    id={`faq-answer-${faq.id}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-5 pt-2 text-gray-600 text-base leading-relaxed border-t border-gray-100">
                      {typeof faq.answer === 'string' ? (
                        faq.answer.split('\n').map((line, i) => (
                          <p key={i} className={i > 0 ? 'mt-2' : ''}>{line}</p>
                        ))
                      ) : (
                        faq.answer
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}
      </div>

      {!filteredFaqs.length && <p className="faq-design-empty">پرسشی با این عبارت پیدا نشد؛ عبارت دیگری را امتحان کنید.</p>}

      {/* بخش تماس — شماره‌های واقعی */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="max-w-4xl mx-auto mt-16 text-center"
      >
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-3xl p-8 border border-amber-200">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            هنوز سوالی دارید؟
          </h2>
          <p className="text-gray-600 mb-6">
            تیم پشتیبانی ما آماده پاسخگویی است
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:03132222042"
              className="inline-flex items-center justify-center gap-2 bg-amber-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-amber-700 transition-colors"
            >
              <Phone className="w-5 h-5" />
              تماس:۳۲۲۲۲۰۴۲-۰۳۱ 
            </a>
            <a
              href="tel:09215316012"
              className="inline-flex items-center justify-center gap-2 border-2 border-amber-600 text-amber-600 px-6 py-3 rounded-xl font-semibold hover:bg-amber-50 transition-colors"
            >
              <Phone className="w-5 h-5" />
              موبایل:۶۰۱۲-۵۳۱-۰۹۲۱
            </a>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
